"use client";
import React from "react";
import Marquee from "react-fast-marquee";
function Index() {
	let zzarr = [
		{ img: "/image/plsyy/about/parner/bosh-640-640.webp" },
		{ img: "/image/plsyy/about/parner/eaton-640-640.webp" },
		{ img: "/image/plsyy/about/parner/HAVE-640-640.webp" },
		{ img: "/image/plsyy/about/parner/HYD-640-640.webp" },
		{ img: "/image/plsyy/about/parner/inter-640-640.webp" },
		{ img: "/image/plsyy/about/parner/JPWORLD-640-640.webp" },
		{ img: "/image/plsyy/about/parner/KA-640-640.webp" },
		{ img: "/image/plsyy/about/parner/linde-640-640.webp" },
		{ img: "/image/plsyy/about/parner/m-640-640.webp" },
		{ img: "/image/plsyy/about/parner/oiit-640-640.webp" },
		{ img: "/image/plsyy/about/parner/pa-640-640.webp" },
		{ img: "/image/plsyy/about/parner/sal-640-640.webp" },
		{ img: "/image/plsyy/about/parner/staff-640-640.webp" },
		{ img: "/image/plsyy/about/parner/sum-640-640.webp" },
		{ img: "/image/plsyy/about/parner/tok-640-640.webp" },
		{ img: "/image/plsyy/about/parner/vic-640-640.webp" },
		{ img: "/image/plsyy/about/parner/wal-640-640.webp" },
		{ img: "/image/plsyy/about/parner/yukun-640-640.webp" },
	];

	return (
		<div className="bg-black/80">
			<div className="box-border w-full py-3 sm:py-4 md:py-[15px]">
				<Marquee speed={80} gradient={false} pauseOnHover={true}>
					<div style={{ display: "flex", gap: "8px" }} className="sm:gap-[10px]">
						{zzarr.map((item, index) => (
							<img 
								key={index} 
								src={item.img} 
								alt={process.env.NEXT_PUBLIC_COMPANY_NAME} 
								className="h-[40px] sm:h-[50px] md:h-[60px] object-contain" 
							/>
						))}
					</div>
				</Marquee>
			</div>
		</div>
	);
}

export default React.memo(Index);
